<template>
    <div class="ClentHome">
        <HomeHeader/>
        <router-view class="HomeBody" />
        <HomeBottom/>
    </div>
</template>
<script>
import HomeHeader from '@/views/HomeHeader'
import HomeBottom from '@/views/HomeBottom'
export default {
    components: {HomeHeader,HomeBottom},
	data() {
		return {
            
		};
	},
    created() {
    },
    mounted(){
    },
    methods: {
    },
    beforeDestroy() {
    }
};
</script>
<style lang="less">
.ClentHome {
    display:flex;
    flex-direction:column;
    justify-content: center;
    align-items: center;
    width:100vw;
    height:100vh;
    .HomeHeader{
        width:100%;
        height:42px;
        // position:absolute;
        // top:0px;
    }
    .HomeBody{
        width:100%;
        overflow-x: hidden;
        overflow-y: auto;
        flex:1;
    }
    .HomeBottom{
        height:50px;
        width:100%;
        // box-shadow: 0px 0px 10px 0px #ccc;
        display:flex;
        justify-content: center;
        align-items: center;
        // position:absolute;
        // bottom:0px;
        // background-color:#F2F6FF;


        box-shadow: 0px 0px 1px 0px #9E99D0;
        background:url('~@/assets/images/qai/bottom.png') 0px 0px no-repeat;
        background-size: 100% 100%;
        .tabs{
            width:100%;
        }
    }
}
</style>